module.exports = __webpack_public_path__ + "static/media/sound_6.2fe4ad35.mp3";